import React, { useState, useRef } from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useFormik } from "formik";
import Alerts from "components/Alerts";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import * as Yup from "yup";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import LoopIcon from "@mui/icons-material/Loop";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import Autocomplete from "@mui/material/Autocomplete";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { FormHelperText } from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import { useApolloClient } from "@apollo/client";
import { SELECTION_SCHEMA_YUP } from "./YupValidation";
import { useUser } from "hooks/useUser";
import { CREATE_EVALUATION_SELECTION } from "./QueryEvaluationSelection";
const CreateSelectionSupplier = ({
  allSupplier,
  criterionSelection,
  allpersonal,
  setnewSelection,
  setAlertCustom,
  alertCustom,
}) => {
  const theme = useTheme();
  const isNonMediumScreens = useMediaQuery("(min-width: 1200px)");
  const today = new Date();
  const { user } = useUser();
  const client = useApolloClient();
  const [error, setError] = useState(false);
  const autocompleteRef = useRef(null);
  const formikSelection = useFormik({
    initialValues: {
      type: "",
      evaluator: {
        label: "",
        id: !user.admin ? user.personal.id : "",
      },
      supplier1: "",
      criteria1: [
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
      ],
      supplier2: "",
      criteria2: [
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
      ],
      supplier3: "",
      criteria3: [
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
        { score: "", criterion: "" },
      ],
    },
    validationSchema: SELECTION_SCHEMA_YUP,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const {
        type,
        evaluator,
        supplier1,
        criteria1,
        supplier2,
        criteria2,
        supplier3,
        criteria3,
      } = values;

      let num1 = criteria1.reduce(
        (acumulador, elemento) => acumulador + Number(elemento.score),
        0
      );
      let num2 = criteria2.reduce(
        (acumulador, elemento) => acumulador + Number(elemento.score),
        0
      );
      let num3 = criteria3.reduce(
        (acumulador, elemento) => acumulador + Number(elemento.score),
        0
      );
      let winnerscore;
      let winnersupplier;
      let uniquemax = true;

      const maximo = Math.max(num1, num2, num3);

      if (num1 === maximo) {
        if (num2 === maximo || num3 === maximo) {
          uniquemax = false;
        } else {
          winnersupplier = supplier1;
          winnerscore = (num1 / criterionSelection.length).toFixed(2);
        }
      } else if (num2 === maximo) {
        if (num1 === maximo || num3 === maximo) {
          uniquemax = false;
        } else {
          winnersupplier = supplier2;
          winnerscore = (num2 / criterionSelection.length).toFixed(2);
        }
      } else if (num3 === maximo) {
        if (num1 === maximo || num2 === maximo) {
          uniquemax = false;
        } else {
          winnersupplier = supplier3;
          winnerscore = (num3 / criterionSelection.length).toFixed(2);
        }
      }
      if (!uniquemax) {
        setError(true);
      } else {
        setError(false);
        const winner = {
          score: Number(winnerscore),
          supplier: winnersupplier,
        };
        console.log(winner);
        setSubmitting(true);

        try {
          const response = await client.mutate({
            mutation: CREATE_EVALUATION_SELECTION,
            variables: {
              type,
              evaluator: evaluator.id,
              supplier1,
              criteria1: criteria1.map(
                (el) =>
                  new Object({
                    score: Number(el.score),
                    criterion: el.criterion,
                  })
              ),
              supplier2,
              criteria2: criteria2.map(
                (el) =>
                  new Object({
                    score: Number(el.score),
                    criterion: el.criterion,
                  })
              ),
              supplier3,
              criteria3: criteria3.map(
                (el) =>
                  new Object({
                    score: Number(el.score),
                    criterion: el.criterion,
                  })
              ),
              winner,
            },
          });

          setnewSelection(response.data.createSelection);
          setAlertCustom({
            type: "success",
            message: "Registro ingresado",
            state: true,
          });
          if (user.admin) {
            autocompleteRef.current.value = "";
          }
          resetForm();
        } catch (error) {
          setAlertCustom({
            ...alertCustom,
            type: "error",
            message: error.message,
            state: true,
          });
        } finally {
          setSubmitting(false);
        }
      }
    },
  });
  return (
    <form onSubmit={formikSelection.handleSubmit}>
      {alertCustom.state && (
        <Alerts alert={alertCustom} setAlertCustom={setAlertCustom}></Alerts>
      )}
      <Box my="20px" display={"flex"} flexDirection={"column"}>
        <Box display="grid" gridTemplateColumns="repeat(1, 1fr)" gap="20px">
          {user.admin ? (
            <>
              {allpersonal?.length ? (
                <Autocomplete
                  freeSolo
                  id="personal"
                  name="personal"
                  ref={autocompleteRef}
                  value={formikSelection.values.evaluator.label}
                  disableClearable
                  options={allpersonal?.map(
                    (option) =>
                      new Object({
                        label:
                          "nombres:" +
                          option.postulant.name +
                          " / " +
                          "apellidos:" +
                          option.postulant.surname +
                          " / " +
                          "dni:" +
                          option.postulant.doi,
                        value: option.id,
                      })
                  )}
                  onChange={(event, newValue) => {
                    formikSelection.setFieldValue("evaluator", {
                      label: newValue.label,
                      id: newValue.value,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Buscar por nombre/apellido/dni"
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                      }}
                      error={
                        formikSelection.touched.evaluator?.id &&
                        Boolean(formikSelection.errors.evaluator?.id)
                      }
                      helperText={
                        formikSelection.touched.evaluator?.id &&
                        formikSelection.errors.evaluator?.id
                      }
                    />
                  )}
                />
              ) : (
                <FormHelperText
                  sx={{ color: "#bf3333", marginLeft: "16px !important" }}
                >
                  <p
                    style={{
                      border: "1px solid",
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  >
                    No hay Datos para mostrar
                  </p>
                </FormHelperText>
              )}
            </>
          ) : null}
          <TextField
            id="type"
            name="type"
            label="TIPO"
            variant="outlined"
            value={formikSelection.values.type}
            onChange={formikSelection.handleChange}
            error={
              formikSelection.touched.type &&
              Boolean(formikSelection.errors.type)
            }
            helperText={
              formikSelection.touched.type && formikSelection.errors.type
            }
          />
        </Box>
        <Box mt={"20px"}>
          <TableContainer style={{ maxHeight: 280, overflowY: "auto" }}>
            <Table stickyHeader aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="">Criterio</TableCell>
                  <TableCell align="">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        PROVEEDOR
                      </InputLabel>
                      <Select
                        id="supplier1"
                        value={formikSelection.values.supplier1}
                        name="supplier1"
                        onChange={formikSelection.handleChange}
                        error={
                          formikSelection.touched.supplier1 &&
                          Boolean(formikSelection.errors.supplier1)
                        }
                      >
                        {allSupplier?.map((option) => {
                          return (
                            <MenuItem key={option.id} value={option.id}>
                              {option.businessname}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {formikSelection.touched.supplier1 &&
                      formikSelection.errors.supplier1 ? (
                        <FormHelperText
                          sx={{
                            color: "#bf3333",
                            marginLeft: "16px !important",
                          }}
                        >
                          {formikSelection.touched.supplier1 &&
                            formikSelection.errors.supplier1}
                        </FormHelperText>
                      ) : null}
                    </FormControl>
                  </TableCell>
                  <TableCell align="">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        PROVEEDOR
                      </InputLabel>
                      <Select
                        id="supplier2"
                        value={formikSelection.values.supplier2}
                        name="supplier2"
                        onChange={formikSelection.handleChange}
                        error={
                          formikSelection.touched.supplier2 &&
                          Boolean(formikSelection.errors.supplier2)
                        }
                      >
                        {allSupplier?.map((option) => {
                          return (
                            <MenuItem key={option.id} value={option.id}>
                              {option.businessname}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {formikSelection.touched.supplier2 &&
                      formikSelection.errors.supplier2 ? (
                        <FormHelperText
                          sx={{
                            color: "#bf3333",
                            marginLeft: "16px !important",
                          }}
                        >
                          {formikSelection.touched.supplier2 &&
                            formikSelection.errors.supplier2}
                        </FormHelperText>
                      ) : null}
                    </FormControl>
                  </TableCell>
                  <TableCell align="">
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-label">
                        PROVEEDOR
                      </InputLabel>
                      <Select
                        id="supplier3"
                        value={formikSelection.values.supplier3}
                        name="supplier3"
                        onChange={formikSelection.handleChange}
                        error={
                          formikSelection.touched.supplier3 &&
                          Boolean(formikSelection.errors.supplier3)
                        }
                      >
                        {allSupplier?.map((option) => {
                          return (
                            <MenuItem key={option.id} value={option.id}>
                              {option.businessname}
                            </MenuItem>
                          );
                        })}
                      </Select>
                      {formikSelection.touched.supplier3 &&
                      formikSelection.errors.supplier3 ? (
                        <FormHelperText
                          sx={{
                            color: "#bf3333",
                            marginLeft: "16px !important",
                          }}
                        >
                          {formikSelection.touched.supplier3 &&
                            formikSelection.errors.supplier3}
                        </FormHelperText>
                      ) : null}
                    </FormControl>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {criterionSelection.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell align="">{row.description}</TableCell>
                    <TableCell align="">
                      <TextField
                        id={`criteria1[${index}].score`}
                        name={`criteria1[${index}].score`}
                        label=""
                        variant="outlined"
                        type="number"
                        value={formikSelection.values.criteria1?.[index]?.score}
                        onChange={(e) => {
                          formikSelection.setFieldValue(
                            `criteria1[${index}].score`,
                            e.target.value
                          );
                          formikSelection.setFieldValue(
                            `criteria1[${index}].criterion`,
                            row.id
                          );
                        }}
                        error={
                          formikSelection.touched.criteria1?.[index]?.score &&
                          Boolean(
                            formikSelection.errors.criteria1?.[index]?.score
                          )
                        }
                        helperText={
                          formikSelection.touched.criteria1?.[index]?.score &&
                          formikSelection.errors.criteria1?.[index]?.score
                        }
                      />
                    </TableCell>
                    <TableCell align="">
                      <TextField
                        id={`criteria2[${index}].score`}
                        name={`criteria2[${index}].score`}
                        label=""
                        variant="outlined"
                        type="number"
                        value={formikSelection.values.criteria2?.[index]?.score}
                        onChange={(e) => {
                          formikSelection.setFieldValue(
                            `criteria2[${index}].score`,
                            e.target.value
                          );
                          formikSelection.setFieldValue(
                            `criteria2[${index}].criterion`,
                            row.id
                          );
                        }}
                        error={
                          formikSelection.touched.criteria2?.[index]?.score &&
                          Boolean(
                            formikSelection.errors.criteria2?.[index]?.score
                          )
                        }
                        helperText={
                          formikSelection.touched.criteria2?.[index]?.score &&
                          formikSelection.errors.criteria2?.[index]?.score
                        }
                      />
                    </TableCell>
                    <TableCell align="">
                      <TextField
                        id={`criteria3[${index}].score`}
                        name={`criteria3[${index}].score`}
                        label=""
                        variant="outlined"
                        type="number"
                        value={formikSelection.values.criteria3?.[index]?.score}
                        onChange={(e) => {
                          formikSelection.setFieldValue(
                            `criteria3[${index}].score`,
                            e.target.value
                          );
                          formikSelection.setFieldValue(
                            `criteria3[${index}].criterion`,
                            row.id
                          );
                        }}
                        error={
                          formikSelection.touched.criteria3?.[index]?.score &&
                          Boolean(
                            formikSelection.errors.criteria3?.[index]?.score
                          )
                        }
                        helperText={
                          formikSelection.touched.criteria3?.[index]?.score &&
                          formikSelection.errors.criteria3?.[index]?.score
                        }
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          {error ? (
            <FormHelperText
              sx={{ color: "#bf3333", marginLeft: "16px !important" }}
            >
              <p
                style={{
                  border: "1px solid",
                  borderRadius: "5px",
                  padding: "10px",
                }}
              >
                tTiene que haber un ganador en la seleccion.
              </p>
            </FormHelperText>
          ) : null}
        </Box>
        <Box display={"flex"} justifyContent={"end"} mt={"15px"}>
          <Button
            variant="contained"
            color="success"
            type="submit"
            disabled={formikSelection.isSubmitting}
          >
            {formikSelection.isSubmitting ? <LoopIcon /> : "GUARDAR"}
          </Button>
        </Box>
      </Box>{" "}
    </form>
  );
};

export default CreateSelectionSupplier;
